export const trimJsonMethod = (request) => {
    var jsonTrim = {}
    Object.keys(request).map((key) => {
        jsonTrim[key] = String(request[key]).trim()
    })
    return jsonTrim
}